import React, { useState } from 'react';
import {
  Dialog, DialogContent, FormControlLabel, 
  Grid, Radio, RadioGroup, TextField, Button, Box, 
  Typography, IconButton
} from '@mui/material';
import { Formik, Form } from 'formik';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import "../css/BioDialogBox.css"; // External CSS

function BioDialogBox({ open, onClose }) {
  const [profileImage, setProfileImage] = useState(null);

  const initialValue = { 
    agentName: '',
    agentTitle: '',
    emailId: '',
    status: '',
  };

  const handleSubmit = (values) => {
    console.log('BioData: ', values);
  };

  const handleProfileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{ className: 'dialog-paper' }}
    >
   <Box className="dialog-header" display="flex" justifyContent="space-between" alignItems="center">
   <h2 className="dialog-title">Edit Agent Bio</h2>
  <Box className="close-button">
    <Button onClick={onClose} className="cancel-button">
      <CancelOutlinedIcon fontSize="small" />
    </Button>
  </Box>

</Box>


      <DialogContent>
        <Formik initialValues={initialValue} onSubmit={handleSubmit}>
          {({ values, handleChange, handleBlur, errors, touched }) => (
            <Form>
              <Grid container justifyContent="flex-start" className="profile-container">
                <Box className="profile-image">
                  {profileImage ? (
                    <img 
                      src={profileImage} 
                      alt="Profile" 
                      className="profile-img"
                    />
                  ) : (
                    <AccountCircleIcon sx={{  width:'100%',
                      height:'100px'
                      }} className="default-icon" />
                  )}

                  <Box className="camera-icon">
                    <input 
                      accept="image/*" 
                      type="file" 
                      id="profile-image-upload" 
                      onChange={handleProfileChange} 
                      className="file-input"
                    />
                    <label htmlFor="profile-image-upload">
                      <IconButton component="span" size="small">
                        <CameraAltOutlinedIcon fontSize="small" />
                      </IconButton>
                    </label>
                  </Box>
                </Box>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography className="field-label">Agent Name</Typography>
                  <TextField
                    id="agentName"
                    name="agentName"
                    label="Add your agent name"
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.agentName}
                    error={touched.agentName && Boolean(errors.agentName)}
                    helperText={touched.agentName && errors.agentName}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="field-label">Agent Title</Typography>
                  <TextField
                    id="agentTitle"
                    name="agentTitle"
                    label="Title"
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.agentTitle}
                    error={touched.agentTitle && Boolean(errors.agentTitle)}
                    helperText={touched.agentTitle && errors.agentTitle}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="field-label">Email ID</Typography>
                  <TextField
                    id="emailId"
                    name="emailId"
                    label="Email ID"
                    type="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.emailId}
                    error={touched.emailId && Boolean(errors.emailId)}
                    helperText={touched.emailId && errors.emailId}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="field-label">Status</Typography>
                  <RadioGroup
                    name="status"
                    value={values.status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <Box>
                      <FormControlLabel value="Sandbox" control={<Radio />} label="Sandbox" className="radio-label" />
                      <FormControlLabel value="Production" control={<Radio />} label="Production" className="radio-label" />
                    </Box>
                  </RadioGroup>
                </Grid>
              </Grid>

              <Box className="save-button-container">
                <Button type="submit" variant="contained" className="save-button">
                  Save
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

export default BioDialogBox;
